import * as ReactBootstrap from "react-bootstrap";
import Moment from "react-moment";
import {ChangeItemProps} from "./types";

export const ChangeItem = ({change}:ChangeItemProps) => {
    return (
        <>
            <ReactBootstrap.Row className={'p-2'}>
                <ReactBootstrap.Col xs="6">
                    <strong> {change.created_by} </strong>
                    <sub>
                        <Moment format="DD-MM-YYYY hh:mm A" local>
                            {change.created_at}
                        </Moment>
                        <sub></sub>
                    </sub>
                </ReactBootstrap.Col>
                <ReactBootstrap.Col className={'text-end'} xs="6">
                    <strong>
                        <Moment fromNow>{change.created_at}</Moment>
                    </strong>
                </ReactBootstrap.Col>
            </ReactBootstrap.Row>
            <ReactBootstrap.Col xs="12">
                <p style={{wordWrap: 'break-word'}} className="p-2 text-justify">
                    {change.value}
                </p>
            </ReactBootstrap.Col>
        </>
    )
}
